import { queryOptions } from '@tanstack/react-query'

import { fetchTheme } from '#admin/features/theme/api.ts'

export const themeQuery = () =>
  queryOptions({
    queryKey: ['tenant', 'theme'],
    queryFn: ({ signal }) => fetchTheme(signal),
  })
